import { render, staticRenderFns } from "./DocumentTable.vue?vue&type=template&id=57d8f0d0"
import script from "./DocumentTable.vue?vue&type=script&lang=js"
export * from "./DocumentTable.vue?vue&type=script&lang=js"
import style0 from "./DocumentTable.vue?vue&type=style&index=0&id=57d8f0d0&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57d8f0d0')) {
      api.createRecord('57d8f0d0', component.options)
    } else {
      api.reload('57d8f0d0', component.options)
    }
    module.hot.accept("./DocumentTable.vue?vue&type=template&id=57d8f0d0", function () {
      api.rerender('57d8f0d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/cv/DocumentTable.vue"
export default component.exports